/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetDetailsPageRequest} from '@cash-web/protos/squareup/cash/messagingplatformcommon/app/GetDetailsPageProto.pb'
import {GetDetailsPageResponse} from '@cash-web/protos/squareup/cash/messagingplatformcommon/app/GetDetailsPageProto.pb'


export const getDetailsPage = (request:GetDetailsPageRequest, options?: CashRequestOptions) => post<GetDetailsPageRequest, GetDetailsPageResponse>("/2.0/cash/get-details-page", request, {...options, rejectOnError: true })